export default __webpack_public_path__ + "static/media/red-dancing-background@2x.2b16ac50.jpg";